/**
* @file 业务设置-基础设置
* */
<template>
  <div id="platform">
    <el-form :model="form" :rules="rules" ref="form" label-width="160px" label-position="left" v-if="mixinUserInfo.platformType !== 4">
      <el-form-item label="自由派单限制" prop="takeOrderLimit" v-if="mixinUserInfo.platformType !== 3">
        <div style="display: flex; align-items: center">
          <el-switch v-model="form.takeOrderLimit" :active-value="1" :inactive-value="2"></el-switch>
          <span class="el-form-item-remark" style="
                  display: inline-block;
                  margin-left: 8px;
                  padding-right: 15px;
                  box-sizing: border-box;
                ">司机在线才能收到自动派单（仅针对自由派单模式）
          </span>
        </div>
      </el-form-item>

      <el-form-item v-if="mixinUserInfo.platformType !== 3"
                    :label="mixinUserInfo.platformType === 2?'窗口售票':'平台下单改价'" prop="systemOrderFeeChange">
        <el-switch v-model="form.systemOrderFeeChange" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark"
              style="display: inline-block; padding-left: 8px">允许{{
            mixinUserInfo.platformType === 2 ? '窗口售票' : '平台下单'
          }}进行改价
        </span>
      </el-form-item>
      <el-form-item label="司机信息识别" prop="isOcr">
        <el-switch v-model="form.isOcr" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">司机注册时自动识别身份证、驾驶证、行驶证信息
        </span>
      </el-form-item>
      <el-form-item label="乘客信息识别" prop="customerOrc">
        <el-switch v-model="form.customerOrc" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">乘客通过小程序购票时可根据身份证照片识别信息
        </span>
      </el-form-item>


      <el-form-item label="站内售票乘客信息识别" prop="stationCustomerOrc" v-if="mixinUserInfo.platformType === 2">
        <el-switch v-model="form.stationCustomerOrc" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">站内售票员通过移动售票小程序售票时可根据身份证照片识别信息
        </span>
      </el-form-item>


      <el-form-item label="推广售票乘客信息识别" prop="mobileCustomerOrc" v-if="mixinUserInfo.platformType === 2">
        <el-switch v-model="form.mobileCustomerOrc" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">推广售票员通过移动售票小程序售票时可根据身份证照片识别信息
        </span>
      </el-form-item>

      <el-form-item label="启用包车业务" v-if="mixinUserInfo.platformType === 1" prop="customerOrc">
        <el-switch v-model="form.chartered" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">开启后可在小程序提交旅游包车订单
        </span>
      </el-form-item>
      <el-form-item label="分机构司机注册" prop="branchOfficeDriverRegister">
        <el-switch v-model="form.branchOfficeDriverRegister" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">允许司机注册到分机构，关闭时司机注册时默认归属总公司
        </span>
      </el-form-item>

      <el-form-item label="司机销单限制" prop="assignVoice" v-if="mixinUserInfo.platformType == 3">
        <div>
          允许销单
          <el-input
              v-model="form.driverCancelNum"
              maxlength="6"
              v-input-filter="{ min: 1, max: 365, precision: 0 }"
              placeholder="司机销单限制"
              style="width: 205px"
          >
            <template slot="append">次</template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="待指派订单提醒" prop="assignVoice" v-if="mixinUserInfo.platformType !== 3">
        <el-switch v-model="form.assignVoice" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">每隔一分钟，语音提醒还有待指派的订单
        </span>
      </el-form-item>
      <el-form-item label="文旅行程派单" prop="travelOrderAssign" v-if="mixinUserInfo.platformType === 1">
        <el-switch v-model="form.travelOrderAssign" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">开启后，系统将自动为行程匹配最优车辆
        </span>
      </el-form-item>

      <el-form-item label="隐私化处理" prop="privacyProcessing" v-if="mixinUserInfo.platformType === 1 || mixinUserInfo.platformType === 2">
        <el-switch v-model="form.privacyProcessing" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">开启后，系统将对敏感信息进行脱敏处理
        </span>
      </el-form-item>

      <el-form-item label="编辑线路免除校验" prop="skipLineOrderCheck" v-if="mixinUserInfo.platformType === 1 || mixinUserInfo.platformType === 2">
        <el-switch v-model="form.skipLineOrderCheck" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">开启后，编辑线路时将免除未完成订单的校验
        </span>
      </el-form-item>

      <el-form-item style="padding: 10px 0 20px 0">
        <el-button type="primary" @click="save" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
    <el-form :model="form" :rules="rules" ref="form" label-width="160px" label-position="left" v-else>
      <el-form-item label="司机信息识别" prop="isOcr">
        <el-switch v-model="form.isOcr" :active-value="1" :inactive-value="2"></el-switch>
        <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">司机注册时自动识别身份证、驾驶证、行驶证信息
        </span>
      </el-form-item>
      <el-form-item style="padding: 10px 0 20px 0">
        <el-button type="primary" @click="save" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-form :model="czForm" :rules="czRules" ref="czForm" label-width="160px" label-position="left" style="width: 800px;" v-else> -->
      <!-- <el-form-item label="司机证件识别" prop="driverOcr">
        <div style="display: flex; align-items: center">
          <el-switch v-model="czForm.driverOcr" :active-value="1" :inactive-value="2" @change="changeSwitch"></el-switch>
          <span class="el-form-item-remark" style="
                  display: inline-block;
                  margin-left: 8px;
                  padding-right: 15px;
                  box-sizing: border-box;
                ">创建司机时可根据身份证照片识别信息
          </span>
        </div>
        <div class="blueInfo">
            司机证件识别采用百度OCR识别方案，如需启用请先开通百度账号，创建OCR识别应用并将应用的：APPID、AK、SK填写到下方
        </div>
        <el-form-item label="AppID" prop="ocrAppId">
          <el-input v-model="czForm.ocrAppId" :maxlength="100" placeholder="请输入百度OCR识别AppID"></el-input>
        </el-form-item>
        <el-form-item label="API Key" prop="ocrAk">
          <el-input v-model="czForm.ocrAk" :maxlength="100" placeholder="请输入百度OCR识别API Key"></el-input>
        </el-form-item>
        <el-form-item label="Secret Key" prop="ocrSk">
          <el-input v-model="czForm.ocrSk" :maxlength="100" placeholder="请输入百度OCR识别Secret Key"></el-input>
        </el-form-item>
      </el-form-item>



      <el-form-item style="padding: 10px 0 20px 0">
        <el-button type="primary" @click="czSave" :loading="loading">保存</el-button>
      </el-form-item> -->
    <!-- </el-form> -->

    <div class="formTitle">乘客客服热线</div>
    <div class="block">
      <el-table border empty-text="暂无数据" :data="tableB">
        <el-table-column label="名称" prop="title"></el-table-column>
        <el-table-column label="电话" prop="servicePhone">
          <template v-slot="{ row }">
            <span @dblclick="$utils.dblclickCopy">{{ row.servicePhone }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template v-slot="{ row }">
            <el-button @click="editB(row)" type="text" size="small">编辑</el-button>
            <el-button type="text" size="small" @click="dltB(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-show="tableB.length < 20" class="add" @click="visibleB = true">
        <i class="el-icon-circle-plus-outline"></i> 添加
      </el-button>
    </div>

    <div class="formTitle">司机客服热线</div>
    <div class="block">
      <el-table border empty-text="暂无数据" :data="tableC">
        <el-table-column label="机构名称" prop="organizationName"></el-table-column>
        <el-table-column label="电话" prop="servicePhone">
          <template v-slot="{ row }">
            <span @dblclick="$utils.dblclickCopy">{{ row.servicePhone }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template v-slot="{ row }">
            <el-button @click="editC(row)" type="text" size="small">编辑</el-button>
            <el-button type="text" size="small" @click="dltC(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-show="tableC.length < 20" class="add" @click="visibleC = true">
        <i class="el-icon-circle-plus-outline"></i> 添加
      </el-button>
    </div>

    <el-dialog :visible.sync="visibleB" @close="$refs.formB.resetFields(); formB.id = null;" width="25%" :title="titleB"
               :close-on-click-modal="false">
      <el-form :model="formB" :rules="rulesB" ref="formB" label-position="left" label-width="80px">
        <el-form-item label="名称" prop="title">
          <el-input v-model="formB.title" maxlength="10" placeholder="展示给乘客的热线名称">
          </el-input>
        </el-form-item>
        <el-form-item label="电话" prop="servicePhone">
          <el-input v-model="formB.servicePhone" @input="formB.servicePhone = formB.servicePhone.replace(/[^\d]/g, '')"
                    maxlength="14" placeholder="请设置手机号或座机号">
          </el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" :loading="loadingB" @click="saveB" style="width: 100%">
        保存
      </el-button>
    </el-dialog>

    <el-dialog :visible.sync="visibleC" @close="
      $refs.formC.resetFields();
    formC.id = null;
    " width="25%" :title="titleC" :close-on-click-modal="false">
      <el-form :model="formC" :rules="rulesC" ref="formC" label-position="left" label-width="80px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select v-model="formC.organizationId" filterable>
            <el-option v-for="(item, index) in organizations" :key="index" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话" prop="servicePhone">
          <el-input v-model="formC.servicePhone" @input="formC.servicePhone = formC.servicePhone.replace(/[^\d]/g, '')"
                    maxlength="14" placeholder="请设置手机号或座机号">
          </el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" :loading="loadingC" @click="saveC" style="width: 100%">
        保存
      </el-button>
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: "platform",
  data() {
    return {
      form: {},
      rules: {},
      czForm: {},
      czRules: {
        ocrAppId: [{ required: true, message: "请输入百度OCR识别AppID", trigger: "blur" }],
        ocrAk: [{ required: true, message: "请输入百度OCR识别API Key", trigger: "blur" }],
        ocrSk: [{ required: true, message: "请输入百度OCR识别Secret Key", trigger: "blur" }],
      },
      loading: false,

      tableB: [],
      visibleB: false,
      loadingB: false,
      titleB: "乘客客服热线",
      formB: {
        type: 1,
        servicePhone: null,
        title: null,
      },
      rulesB: {
        title: [{required: true, message: "请输入热线名称"}],
        servicePhone: [
          {required: true, message: "请输入热线号码"},
          {pattern: /^[-\d]{7,14}$/, message: "请输入7-14位的联系方式"},
        ],
      },

      tableC: [],
      visibleC: false,
      loadingC: false,
      titleC: "司机客服热线",
      formC: {
        type: 2,
        organizationId: null,
        servicePhone: null,
      },
      rulesC: {
        organizationId: [{required: true, message: "请选择机构"}],
        servicePhone: [
          {required: true, message: "请输入热线号码"},
          {pattern: /^[-\d]{7,14}$/, message: "请输入7-14位的联系方式"},
        ],
      },
      tableD: [{}],
      formD: {},
      visibleD: false
    };
  },
  created() {
    this.mixinOrganizations();
    if(this.mixinUserInfo.platformType == 4) {
      // this.ocrGet()
      this.formAGet();
    }else {
      this.formAGet();
    }

    this.tableBGet();
    this.tableCGet();
    this.tableDGet();


  },
  methods: {
    changeSwitch(value) {
      Object.keys(this.czRules).forEach((item) => {
        this.czRules[item][0].required = value == 1 ? true : false;
      });
    },
    /* 获取开关配置详情 */
    async formAGet() {
      let url = "/api/v1/manage/systems";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.form = data.data || {};
      }
    },
    /* 获取ocr配置详情 */
    async ocrGet() {
      let url = "/api/v1/manage/airport/config";
      let {code, data} = await this.$axios.get(url);
      if (code === 1) {
        this.czForm = data || {};
        this.changeSwitch(data.driverOcr)
      }
    },

    /* 保存 */
    async czSave() {
      this.$refs.czForm.validate((valid) => {
        if (valid) {
          this.czSavePost();
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /* 提交开关配置*/
    async czSavePost() {
      this.loading = true;
      let url = "/api/v1/manage/airport/config";
      let params = {
        driverOcr: this.czForm.driverOcr,
        ocrAppId: this.czForm.ocrAppId,
        ocrAk: this.czForm.ocrAk,
        ocrSk: this.czForm.ocrSk,
      }
      let {code} = await this.$axios.post(url, params);
      if (code === 1) {
        this.$message.success("保存成功！");
        this.ocrGet();
      }
      this.loading = false;
    },
    /* 保存 */
    async save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.savePost();
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /* 提交开关配置*/
    async savePost() {
      this.loading = true;
      let url = "/api/v1/manage/systems";
      let params = this.$utils.deepCopyFn(this.form);
      let data = await this.$axios.put(
          url,
          Object.assign(params, {systemFlag: 1})
      );
      if (data && data.code === 1) {
        this.$message.closeAll();
        this.$message.success("保存成功！");
        this.formAGet();
        this.$store.dispatch("acAssignVoice");
      } else if (data && data.code === 51021) {
        this.formAGet();
      }
      this.loading = false;
    },

    /* 获取乘客热线列表 */
    async tableBGet() {
      let url = "/api/v1/manage/systems/servicePhone";
      let data = await this.$axios.get(url, {type: 1});
      if (data && data.code === 1) {
        this.tableB = data.data || [];
      }
    },

    /* 获取司机热线列表 */
    async tableCGet() {
      let url = "/api/v1/manage/systems/servicePhone";
      let data = await this.$axios.get(url, {type: 2});
      if (data && data.code === 1) {
        this.tableC = data.data || [];
      }
    },

    async tableDGet() {
      let url = "/api/v1/manage/hitchRide/withdrawalConfig";
      let data = await this.$axios.get(url, {type: 2});
      if (data && data.code === 1) {
        this.tableD = data.data || [];
      }
    },

    async saveB() {
      this.$refs.formB.validate(async (valid) => {
        if (valid) {
          this.loadingB = true;
          let url = " /api/v1/manage/systems/servicePhone";
          let params = {
            id: this.formB.id,
            title: this.formB.title,
            servicePhone: this.formB.servicePhone,
            type: 1,
          };
          let data = await this.$axios.post(url, params);
          if (data && data.code === 1) {
            this.$message.success("保存成功！");
            this.tableBGet();
            this.visibleB = false;
          }
          this.loadingB = false;
        }
      });
    },
    async saveC() {
      this.$refs.formC.validate(async (valid) => {
        if (valid) {
          this.visibleC = true;
          let url = " /api/v1/manage/systems/servicePhone";
          let params = {
            id: this.formC.id,
            organizationId: this.formC.organizationId,
            servicePhone: this.formC.servicePhone,
            type: 2,
          };
          let data = await this.$axios.post(url, params);
          if (data && data.code === 1) {
            this.$message.success("保存成功！");
            this.tableCGet();
            this.visibleC = false;
          }
          this.loadingB = false;
        }
      });
    },

    async editB(row) {
      this.visibleB = true;
      this.$nextTick(() => {
        this.formB = this.$utils.deepCopyFn(row);
      });
    },

    async editC(row) {
      this.visibleC = true;
      this.$nextTick(() => {
        this.formC = this.$utils.deepCopyFn(row);
      });
    },

    /* 删除乘客热线 */
    async dltB(id) {
      this.$confirm("确认删除吗？", "删除提示").then(async () => {
        let data = await this.$axios.delete(
            "/api/v1/manage/systems/servicePhone",
            {id}
        );
        if (data && data.code === 1) {
          this.tableBGet();
          this.$message.success("删除成功");
        }
      });
    },

    /* 删除司机热线 */
    async dltC(id) {
      this.$confirm("确认删除吗？", "删除提示").then(async () => {
        let data = await this.$axios.delete(
            "/api/v1/manage/systems/servicePhone",
            {id}
        );
        if (data && data.code === 1) {
          this.tableCGet();
          this.$message.success("删除成功");
        }
      });
    },
    handClose(){
      this.formD = {}
      this.visibleD = false
      this.tableDGet()
    },
    editD(row) {
      this.formD = {
        ...row
      }
      this.visibleD = true
    }

  },
};
</script>

<style lang="less">
#platform {
  padding: 20px 0;

  .el-form {
    .el-form-item {
      margin-bottom: 20px;
      
      .el-form-item__label {
        font-weight: 500;
        color: #303133;
      }
    }

    .el-form-item-remark {
      display: inline-block;
      margin-left: 8px;
      font-size: 12px;
      color: #909399;
    }

    // 保存按钮区域
    .el-form-item:last-child {
      margin-top: 24px;
      padding-top: 20px;
      border-top: 1px solid #ebeef5;
      
      .el-button {
        min-width: 100px;
        border-radius: 6px;
      }
    }
  }

  .el-radio-item .el-radio__label {
    font-weight: 600;
    color: #222222;
  }

  .el-radio-item + .el-radio-item {
    padding-top: 8px;
  }

  .el-radio-item .el-form-item-remark {
    padding-top: 8px;
  }

  .formTitle {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    padding: 16px 0 12px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 16px;
  }

  .block {
    max-width: 800px;
    padding-bottom: 40px;

    .el-table {
      border-radius: 8px;
      
      th {
        background: #f5f7fa;
      }
    }

    .add {
      width: 100%;
      padding: 12px;
      margin-top: 16px;
      border: 1px dashed #c0c4cc;
      border-radius: 8px;
      background: #fafbfc;
      color: #606266;
      transition: all 0.2s;
      
      &:hover {
        border-color: #2B77FF;
        color: #2B77FF;
        background: #f0f7ff;
      }
      
      i {
        margin-right: 4px;
      }
    }
  }

  // 弹窗样式
  .el-dialog {
    .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
    }
    
    .el-dialog__body {
      padding: 20px;
    }
    
    .el-form {
      .el-form-item:last-child {
        margin-top: 0;
        padding-top: 0;
        border-top: none;
      }
    }
    
    .el-button[style*="width: 100%"] {
      border-radius: 6px;
    }
  }
}
</style>
